import { AfterViewInit, Component , OnInit } from '@angular/core';
import { SidebarService } from '../sidebar/sidebar.service';
import { ShareService } from '../services/share-service';
import * as $ from 'jquery';
import 'metismenu';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss']
})

export class NavbarComponent implements OnInit{

    profile:any;
    avatar:any = "";

    constructor(private sidebarservice: SidebarService, private shareService:ShareService) { }

        
    toggleSidebar() {
        this.sidebarservice.setSidebarState(!this.sidebarservice.getSidebarState());
    }
    
    getSideBarState() {
        return this.sidebarservice.getSidebarState();
    }

    hideSidebar() {
        this.sidebarservice.setSidebarState(true);
    }

    ngOnInit() {

        /* Search Bar */
        $(document).ready(function () {


            $(document).on("click", function(event){
                if (!$(event.target).closest('.user-box').length) {
                    $(".user-box ul").removeClass("show").removeAttr("data-bs-popper");
                }
            });
            // $('#top-nav-menu').metisMenu();
            // top-menu
            $('.user-box').on("click", function(){
                var $ul = $(this).children("ul");
                if ($ul.hasClass("show")) {
                    $ul.removeClass("show").removeAttr("data-bs-popper");
                } else {
                    $ul.addClass("show").attr("data-bs-popper","static");
                }

                event.stopPropagation(); // Prevent the click event from propagating to the document
            });
           

            $(".mobile-search-icon").on("click", function () {
                $(".search-bar").addClass("full-search-bar")
            }), 
            $(".search-close").on("click", function () {
                $(".search-bar").removeClass("full-search-bar")
            })

            // $("#user-box-menu").on("click", function () {
            //     alert("clicked");
            //     $(".dropdown a").addClass("show")
            // })
            
        });

        this.profile = this.shareService.getUser();

        this.avatar = this.shareService.getClientAvartar();
    }

    handleLogout() {
        // const oldToken = this.signInService.getCurrentToken();
        // console.log('OLD TOKEN NEW 111:', oldToken);
        // this.signInService.logout();
        /*this.signInService.getToken().subscribe(v => {
            console.log('OLD TOKEN:', v);
            this.signInService.logout();
        });*/
        // alert("sign out");
    }
    onClick(){

    }
}
